



























































import {Mixins, Component} from 'vue-property-decorator';
import NoticeCategoryData from '@/components/board/mixins/NoticeCategoryData';
import {NoticeFormData} from '@/types';
import {GetNoticePublicNoticeNoRequest, ManageNoticeTargetType} from 'supporter';
import {getStorageByName} from '@/utils/excel';

@Component
export default class QueryNoticeByNoticeNo extends Mixins(NoticeCategoryData) {
  private formData: NoticeFormData = {
    noticeCategory: '',
    noticeContent: '',
    createdDateTime: '',
    noticeTitle: '',
    noticeNo: 0,
    noticeAttachFiles: []
  };

  private close(): void {
    window.close();
  }

  private created(): void {
    document.body.classList.add('popup');
    const request: GetNoticePublicNoticeNoRequest = {
      pathParams: {
        noticeNo: this.$route.params.noticeNo
      },
      params: {
        noticeTarget: this.$route.query.noticeTarget as ManageNoticeTargetType
      }
    };

    this.$api
      .getNoticeNoticeNo(request)
      .then((result): void => {
        const {data} = result;
        this.formData = Object.assign({}, this.formData, {...data});
      })
      .finally(() => {});
  }
  downloadFile(file: any) {
    getStorageByName(file.uploadedFileName, file.originalFileName, 'ncp');
    // const params = {container: 'ncp', fileName: file.uploadedFileName};
    // axios({
    //   headers: {
    //     Version: process.env.VUE_APP_STORAGE_API_VERSION
    //   },
    //   params,
    //   method: 'get',
    //   url: `${process.env.VUE_APP_STORAGE_API_URL}/storage`,
    //   responseType: 'blob'
    // }).then((ret: any) => {
    //   const myBlob = new window.Blob([ret.data], {type: 'blob'});
    //   const qrUrl = window.URL.createObjectURL(myBlob);
    //   const a = document.createElement('a');
    //   const event = new MouseEvent('click');
    //   a.download = file.originalFileName;
    //   a.href = qrUrl;
    //   a.dispatchEvent(event);
    //   window.URL.revokeObjectURL(qrUrl);
    // });
  }
}
